import React, { useEffect, useState } from 'react';
import { Navigate, Link} from 'react-router-dom';
import LoaderInfiniteLoop from 'widgets/loaderInfiniteLoop';
import { Card, Nav, Tab } from 'react-bootstrap';
import SimpleBar from 'simplebar-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MyAdvancedTable from 'components/common/myAdvancedTable/myAdvancedTable';
import moment from 'moment-timezone';
import SubtleBadge from 'components/common/SubtleBadge';
import IconAlert from 'components/common/IconAlert';

import { Axios } from 'helpers/axios';
import HabilitationService from 'services/habilitationsService';
import DocDPSsignModal from './DocDPSsignModal';

const MesDPS = () => {
    const [dps, setDps] = useState([]);
    const [documentsToSign, setDocumentsToSign] = useState([]);
    const [demandes, setDemandes] = useState([]);
    const [isLoading, setIsLoading] = useState(true)
    const initPage = async () => {
        try {
            const getDPS = await Axios.get('/authenticatedRoutes/dps/getAllDpsOneClient');
            setDps(getDPS.data);

            const getDemandes = await Axios.get('/authenticatedRoutes/dps/getOpenDemandesOneClient');
            setDemandes(getDemandes.data);

            const getDocumentsToSign = await Axios.get('/authenticatedRoutes/dps/getDocumentsToSign');
            setDocumentsToSign(getDocumentsToSign.data);

            setIsLoading(false)
        } catch (error) {
            console.error(error)
        }
    }
    
    useEffect(()=>{
        initPage();
    },[])

    const colonnes = [
        {
            accessorKey: 'idDPS',
            header: '#',
        },
        {
            accessorKey: 'nomStructureClient',
            header: 'Client',
            isHidden: HabilitationService.habilitations.structures.length < 2,
        },
        {
            accessorKey: 'libelleDPS',
            header: 'Evènement',
            cell: ({ row }) => {
                return(<Link to={"/auth/dps/"+row.original.idDPS}>{row.original.libelleDPS}</Link>);
            },
        },
        {
            accessorKey: 'debutDPS',
            header: 'Date',
            cell: ({ row }) => {
                return(moment(row.original.debutDPS).format('dddd DD/MM/YYYY'));
            },
        },
        {
            accessorKey: 'libelleStatutDPS',
            header: 'Statut',
            cell: ({ row }) => {
                return(<SubtleBadge bg={row.original.bgStatutDPS}>{row.original.libelleStatutDPS}</SubtleBadge>);
            },
        },
    ];

    return (<>
        {HabilitationService.habilitations['structures'].length == 0 ?
            <Navigate to="/auth/mesStructures" />
        :
            isLoading ?
                <LoaderInfiniteLoop />
            :
                <>
                    {demandes.length > 0 ?
                        demandes.map((demande, i)=>{return(
                            <IconAlert key={i} variant={'warning'}>
                                Vous avez entamé une demande de DPS mais ne l'avez pas encore soumise:<br/>
                                Evènement: {demande.libelleEvenement ? <>{demande.libelleEvenement}</> : <>A définir</>}<br/>
                                Date: {demande.dateDebutEvenement ? <>{moment(demande.dateDebutEvenement).format('DD/MM/YYYY')}</> : <>A définir</>}<br/>
                                <Link to={"/demandeDPS/"+demande.demandeUpdateCode}>Terminez de soumettre votre demande au plus vite !</Link>
                            </IconAlert>
                        )})
                    : null}

                    {documentsToSign.length > 0 ?
                        <>
                            <IconAlert variant={'warning'}>
                                Un document requiert votre signature:<br/>
                                {documentsToSign.map((doc, i)=>{return(
                                    <DocDPSsignModal key={i} doc={doc} />
                                )})}
                            </IconAlert>
                        </>
                    : null}
                    
                    <Card className="mb-3">
                        <Tab.Container defaultActiveKey="enCours">
                            <SimpleBar>
                                <Card.Header className="p-0 border-bottom">
                                    <Nav className="nav-tabs border-0 flex-nowrap tab-contact-details">
                                        <Nav.Item>
                                            <Nav.Link eventKey="enCours" className="d-flex align-items-center py-3 px-x1 mb-0">
                                                <FontAwesomeIcon icon="ambulance" className="text-600 tab-icon"/>
                                                <h6 className="text-600 mb-0 ms-1">Dossiers en cours</h6>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="clos" className="d-flex align-items-center py-3 px-x1 mb-0">
                                                <FontAwesomeIcon icon="check" className="text-600 tab-icon"/>
                                                <h6 className="text-600 mb-0 ms-1">Dossiers clos</h6>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Header>
                            </SimpleBar>
                            <Card.Body className="bg-light">
                                <Tab.Content>
                                    <Tab.Pane eventKey="enCours">
                                        <MyAdvancedTable
                                            columns={colonnes}
                                            data={dps.filter(dps => dps.statutDPSclos == false)}
                                            topButtonShow={false}
                                        />
                                        <br/>
                                        <center><i>Vous ne retrouvez pas votre poste de secours ? Pas de panique, <Link to={'/contact'}>contactez nous</Link> !</i></center>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="clos">
                                        <MyAdvancedTable
                                            columns={colonnes}
                                            data={dps.filter(dps => dps.statutDPSclos == true)}
                                            topButtonShow={false}
                                        />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Card.Body>
                        </Tab.Container>
                    </Card>
                </>
        }
    </>);
};

export default MesDPS;